import React from 'react';
import { FormattedMessage } from 'react-intl';

// Returns `true` if non-empty `text/html` is included in the data transfer.
//
// @param {module:clipboard/datatransfer~DataTransfer} dataTransfer
// @returns {Boolean}
export function isHtmlIncluded(dataTransfer) {
  return (
    Array.from(dataTransfer.types).includes('text/html') &&
    dataTransfer.getData('text/html') !== ''
  );
}

export const Fallback = (): React.ReactElement => (
  <p>
    <FormattedMessage id="rte.error" />
  </p>
);
